import EFOcats_answer from './efocats_answer.js';
import EFOcats_import_html from '../import/efocats_import_html.js';

/**
 * typeLabel[j] === "textarea"の時の回答欄設置処理
 */
export default class efocats_answer_textarea extends EFOcats_answer {
  /**
   * 回答欄設置
   */
  set(tmp, answer, elem) {
    let line = 0;

    if (answer.line) {
      line = answer.line;
    }

    if (elem.find('.inner').length <= answer.line) {
      elem
        .find('.inner')
        .last()
        .after(EFOcats_import_html.getValue('common-question-double', {name: answer.name}));
    }

    const input = elem
      .find('.inner')
      .eq(line)
      .append(EFOcats_import_html.getValue('textarea-question-option', {name: answer.name}));
    elem.find('.cat-txt').eq(line).attr('target-name', answer.name);
    this.attr(input.find('textarea').last().get(0), answer, elem);
  }
}
